import { Toaster as SonnerToaster, toast as sonnerToast, type ExternalToast } from 'sonner';

import { ErrorIcon, SuccessIcon } from '../icons';

/**
 * Toasts confirm the user's own action when the result is not otherwise visible,
 * or offer Undo. One at a time, 5 seconds, bottom inline-end.
 * Never for errors shown inline, validation, polling updates or other users' activity.
 * White overlay surface with a 3px tone rule at the inline start: success = green check, error = red icon,
 * Undo = neutral rule.
 */
export function Toaster({ dir }: { dir: 'ltr' | 'rtl' }) {
  return (
    <SonnerToaster
      dir={dir}
      position={dir === 'rtl' ? 'bottom-left' : 'bottom-right'}
      visibleToasts={1}
      duration={5000}
      gap={8}
      offset={20}
      icons={{ success: <SuccessIcon className="text-positive" />, error: <ErrorIcon className="text-negative" /> }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-90 items-center gap-3 rounded-md border border-s-3 border-border bg-surface px-3.5 py-2.5 text-body text-ink shadow-overlay',
          icon: 'flex shrink-0 items-center',
          title: 'font-medium',
          description: 'text-meta text-ink-secondary',
          actionButton:
            'ms-auto h-6 rounded-sm border border-border-strong px-2 text-meta font-medium text-ink hover:bg-row-hover',
          default: 'border-s-border-strong',
          success: 'border-s-positive',
          error: 'border-s-negative',
        },
      }}
    />
  );
}

export const toast = {
  done(message: string, options?: ExternalToast) {
    return sonnerToast.success(message, options);
  },
  withUndo(message: string, undoLabel: string, onUndo: () => void) {
    return sonnerToast(message, { action: { label: undoLabel, onClick: onUndo } });
  },
  error(message: string, options?: ExternalToast) {
    return sonnerToast.error(message, options);
  },
};
